import React from 'react';
import { Link } from 'react-scroll';
import { ResponsiveImage, ResponsiveImageSize } from 'react-responsive-image';

const HomeAboutText = () => {
    return (
        <div id="about-text" className="wrapper">
            <div className="row gutter-width-md with-pb-md">
                <div className="col-sm-12 col-md-5 col-lg-5 col-xl-5">
                    <div className="description-2">
                        <h2>Mission Statement</h2>
                    </div>

                    <div className="signature spacer m-top-xs">
                        <div className="clinic-img">
                            <ResponsiveImage>
                                <ResponsiveImageSize
                                    default
                                    minWidth={0}
                                    path={"assets/img/home/ClubSmall.jpg"}
                                />
                                <ResponsiveImageSize
                                    minWidth={768}
                                    path={"assets/img/home/ClubXS.jpg"}
                                />
                                <ResponsiveImageSize
                                    minWidth={800}
                                    path={"assets/img/home/ClubSmall.jpg"}
                                />
                                <ResponsiveImageSize
                                    minWidth={1100}
                                    path={"assets/img/home/ClubMedium.jpg"}
                                />
                                <ResponsiveImageSize
                                    minWidth={1400}
                                    path={"assets/img/home/ClubLarge.jpg"}
                                />
                            </ResponsiveImage>
                        </div>
                    </div>
                </div>

                <div className="col-sm-12 col-md-7 col-lg-7 col-xl-7">
                    <div className="description-2 bold">
                        <p>At Botany Physio, Julia is an experienced physio with many years of practice, further education and postgraduate training. We offer a diverse knowledge and skill set to meet the needs of our community.</p>
                        <p>We are an ACC Contracted Supplier and Southern Cross Easy-Claim Affliated Provider that aims to help people with all their Physiotherapy needs.</p>
                        <p>Please feel free to look at our vast range of treatments and our appointment options using the buttons below:</p>
                    </div>

                    <div className="button spacer m-top-lg">
                        <Link to="appointments" href="#appointments" className="btn border btn-primary scroll-to-id">See Our Appointments</Link> &nbsp;
                        <Link to="treatments" href="#treatments" className="btn border btn-primary scroll-to-id">See Our Treatments</Link>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default HomeAboutText;
